import React, { useState } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { myContext } from "../provider"
import Logo from "../images/logo.svg"
import LanguageSwitcher from "../components/language-switcher"
import SocialMedias from "./mdx-components/social-medias"
import { useStaticQuery, graphql } from "gatsby"

import "./styles/header.scss"

const Header = () => {
  const [menuOpened, setMenuOpened] = useState(false)
  const data = useStaticQuery(graphql`
    query {
      allMdx(sort: { order: ASC, fields: frontmatter___menuOrder }) {
        edges {
          node {
            fileAbsolutePath
            frontmatter {
              language
              slug {
                current
              }
              pageTitle
              menuTitle
              menuOrder
            }
          }
        }
      }
    }
  `)

  return (
    <myContext.Consumer>
      {context => (
        <header>
          <div className="logo">
            <Link role="button" to="/">
              <img src={Logo} alt="thomas morice logo" />
            </Link>
          </div>
          <div
            className={`hamburger-menu ${menuOpened ? "is-menu-opened" : ""}`}
            role="button"
            onClick={() => setMenuOpened(!menuOpened)}
            onKeyDown={e => setMenuOpened(!setMenuOpened)}
            tabIndex={0}
          >
            {/*Hamburger menu lines */}
            <div />
            <div />
          </div>
          <div className={`menu ${menuOpened ? "is-opened" : ""}`}>
            <div className="background"></div>
            <div className="language-switcher-and-profile-picture">
              <LanguageSwitcher />
              <div className="profile-picture"> </div>
            </div>
            <div className="page-links">
              <ul>
                {data.allMdx.edges
                  .filter(
                    mdx =>
                      mdx.node.frontmatter.language === context.currentLanguage
                  )
                  .map(({ node }) => {
                    return (
                      <li key={node.frontmatter.menuOrder}>
                        <Link
                          to={`/${node.frontmatter.language}/${node.frontmatter.slug.current}`}
                        >
                          {node.frontmatter.menuTitle}
                        </Link>
                      </li>
                    )
                  })}
              </ul>
            </div>
            <div className="social-medias-container">
              <SocialMedias />
            </div>
          </div>
        </header>
      )}
    </myContext.Consumer>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
